module.exports = __webpack_public_path__ + "static/media/top-offer-banner3.ae3c1ed8.jpg";